import React from 'react';
import ExplorePage from './explore';

function MyArksPage({appState}) {
  return <ExplorePage appState={appState} myArks={true} />
}

export default MyArksPage;